import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
} from '@chakra-ui/react'

export const RequestRandomForm = ({ register, errors }) => {
  return (
    <form>
      <FormControl isInvalid={errors.randomWordsCount}>
        <FormLabel htmlFor="randomWordsCount">Random Words Amount</FormLabel>
        <Input
          id="randomWordsCount"
          {...register('randomWordsCount', {
            required: 'This field is required',
            pattern: {
              value: /^[1-9][0-9]*$/,
              message: 'Please enter only numbers greater than 0.',
            },
          })}
          borderColor={'primary.100'}
          type="number"
        />
        <FormErrorMessage>
          {errors.randomWordsCount && errors.randomWordsCount.message}
        </FormErrorMessage>
      </FormControl>
      <FormControl mt={2} isInvalid={errors.confirmationsAmount}>
        <FormLabel htmlFor="confirmationsAmount">
          Get answer after blocks
        </FormLabel>
        <Input
          id="confirmationsAmount"
          {...register('confirmationsAmount', {
            required: 'This field is required',
            pattern: {
              value: /^[1-9][0-9]*$/,
              message: 'Please enter only numbers greater than 0.',
            },
            min: {
              value: 3,
              message: 'Minimum value must be 3.',
            },
          })}
          borderColor={'primary.100'}
          type="number"
        />
        <FormErrorMessage>
          {errors.confirmationsAmount && errors.confirmationsAmount.message}
        </FormErrorMessage>
      </FormControl>
    </form>
  )
}
